/**
 * Supported UI languages (TO-418 customer-ui REQ-001) and the pure resolution
 * order: the user's stored choice → the browser's primary language subtag →
 * Spanish.
 */
export const SUPPORTED_LANGUAGES = ['es', 'gl', 'en', 'pt'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const FALLBACK_LANGUAGE: SupportedLanguage = 'es'
/** localStorage key holding the user's explicit choice. */
export const LANGUAGE_STORAGE_KEY = 'today.language'

const isSupported = (value: string | null | undefined): value is SupportedLanguage =>
	!!value && (SUPPORTED_LANGUAGES as readonly string[]).includes(value)

/** `gl-ES` → `gl`. */
const primarySubtag = (tag: string): string => tag.toLowerCase().split('-')[0]

export const resolveLanguage = (stored: string | null, browserLanguages: readonly string[]): SupportedLanguage => {
	if (isSupported(stored)) return stored
	const browser = browserLanguages.map(primarySubtag).find(isSupported)
	return browser ?? FALLBACK_LANGUAGE
}
